import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ActivityFormData } from '../../components/activity/activityForm';

interface EmployeeCardState {
  employeeId: string;
  lastLoggedActivity: ActivityFormData | null;
}

const initialState: {
  isExportDialogVisible: boolean;
  employeeCardState: EmployeeCardState;
} = {
  isExportDialogVisible: false,
  employeeCardState: {
    employeeId: '',
    lastLoggedActivity: null,
  },
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setIsExportDialogVisible: (state, action) => {
      state.isExportDialogVisible = action.payload;
    },
    setEmployeeCardState: (state, action) => {
      state.employeeCardState = { ...action.payload };
    },
  },
});

export const reportsReducer = reportsSlice.reducer;
export const { setIsExportDialogVisible, setEmployeeCardState } =
  reportsSlice.actions;
export const selectIsDialogVisible = (root: RootState): boolean =>
  root.reports.isExportDialogVisible;
export const selectEmployeeCardState = (root: RootState): EmployeeCardState =>
  root.reports.employeeCardState;
